import { useNavigate } from 'react-router-dom'
import { Icon } from '@carrent/ui'

/** Гаджет: Инциденты: смешанная лента. */

const INCIDENT_ICON = { damage: 'warning', repair: 'wrench', ticket: 'chat' }

export function IncidentsWidget({ data }) {
  const navigate = useNavigate()

  if (!data.items.length) {
    return <p className="widget-empty">Открытых инцидентов нет</p>
  }

  return (
    <div className="incidents">
      <div className="incidents__summary">
        <span className="chip chip--danger">{data.counts.danger} критичных</span>
        <span className="text-muted">всего {data.counts.total}</span>
      </div>

      <ul className="widget-list">
        {data.items.map((it, i) => (
          <li key={`${it.kind}-${i}`}>
            <button
              type="button"
              className="incidents__row"
              onClick={() => navigate(it.link)}
            >
              <span className={`incidents__icon incidents__icon--${it.level}`}>
                <Icon name={INCIDENT_ICON[it.kind]} size={16} />
              </span>
              <span className="incidents__main">
                <span className="incidents__title">{it.title}</span>
                <span className="incidents__meta">
                  {it.kind_label}
                  {it.car ? ` · ${it.car}` : ''}
                  {it.plate ? <span className="plate">{it.plate}</span> : null}
                </span>
              </span>
            </button>
          </li>
        ))}
      </ul>
    </div>
  )
}
